import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Label, TabBar, TabItem } from '../components';
import cn from 'classnames';
import styles from './LandscapeBaseEditTemplate.module.css';

interface LandscapeStoryBaseAddTemplateProps {
  children: React.ReactNode;
}

const LandscapeStoryBaseAddTemplate: React.FC<
  LandscapeStoryBaseAddTemplateProps
> = ({ children }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content={'Create Landscape Story'} size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate(`/landscapes/edit/${id}/updates`)}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="Story"
          id={`/landscapes/edit/${id}/updates/story/add`}
        />
        <TabItem title="Content Blocks" disabled id={''} />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeStoryBaseAddTemplate;
